module.exports = __webpack_public_path__ + "static/media/5th.4bd6e1ad.jpg";